export const ApiMethods = [
  Object.freeze({
    id: "GET",
    name: "GET",
    bgColor: "#61affe",
    color: "#ffffff",
  }),
  Object.freeze({
    id: "POST",
    name: "POST",
    bgColor: "#49cc90",
    color: "#ffffff",
  }),
  Object.freeze({
    id: "PUT",
    name: "PUT",
    bgColor: "#fca130",
    color: "#ffffff",
  }),
  Object.freeze({
    id: "DELETE",
    name: "DELETE",
    bgColor: "#f93e3e",
    color: "#ffffff",
  }),
];

export const ApiMethodsFilter = [
  Object.freeze({
    id: "",
    name: "All",
  }),
  ...ApiMethods,
];

export const getApiMethodsIdByName = (ApiMethodsName) => {
  return (
    ApiMethods.find((ApiMethods) => ApiMethods.name === ApiMethodsName)?.id ||
    ""
  );
};

export const getApiMethodsName = (ApiMethodsValue) => {
  return (
    ApiMethods.find(
      (ApiMethods) => ApiMethods.id === ApiMethodsValue.toString()
    )?.name || ""
  );
};

export const getApiMethodsById = (id) => {
  return ApiMethods.find((ApiMethods) => ApiMethods.id === id) || "";
};
